module.exports = __webpack_public_path__ + "img/logo.cda7c9e2.webp";